import { useAppSelector } from '../../../../store/hooks'
import { FC } from 'react'
import JsonView from '@uiw/react-json-view'
import XMLViewer from 'react-xml-viewer'
import { darkTheme } from '@uiw/react-json-view/dark'
import { lightTheme } from '@uiw/react-json-view/light'
import { SitemapFormatType } from './service'

interface ResultContainerProps {
    result: object
    viewType?: SitemapFormatType
}

const ResultContainer: FC<ResultContainerProps> = ({
    result,
    viewType = 'json',
}) => {
    const theme = useAppSelector((state) => state.theme.theme)
    return (
        <div className="text-justify text-wrap">
            {(() => {
                switch (viewType) {
                    case 'xml':
                        return (
                            <div className={`p-3 xml-viewer`}>
                            <XMLViewer
                                xml={result?.['data']?.['sitemap'] || ''}
                                theme={{
                                    textColor: theme === 'dark' ? '#eee' : '#222',
                                    separatorColor: theme === 'dark' ? '#bbb' : '#222',
                                }}
                                collapsible
                            />
                            </div>
                        )
                    case 'json':
                    default:
                        return (
                            <JsonView
                                value={result}
                                style={
                                    theme === 'dark' ? darkTheme : lightTheme
                                }
                            />
                        )
                }
            })()}
        </div>
    )
}

export default ResultContainer
